<template>
  <div class="register-container">
    <div class="header-title" >注册新会员</div>
    <div class="form">
      <div class="form-item">
        <div class="title">+86</div>
        <div class="content">
          <input type="text" placeholder="手机号"  maxlength="11" v-model="phone" />
          <div class="tips"></div>
        </div>
      </div>

      <div class="form-item">
        <div class="title">姓名</div>
        <div class="content">
          <input type="text" placeholder="" v-model="nickName" maxlength="12"/>
          <div class="tips"></div>
        </div>
      </div>

      <div class="form-item">
        <div class="title">推荐人</div>
        <div class="content">
          <input type="text" placeholder="推荐人会员号" v-model="spread_phone"  @blur="getOtherAccount1"  />
          <div class="tips">{{other_nickname1}}</div>
        </div>
      </div>

      <div class="form-item">
        <div class="title">登录密码</div>
        <div class="content">
          <input type="password" placeholder="新会员(6~16位字母+数字)" v-model="password"  />
          <div class="tips"></div>
        </div>
      </div>
      <div class="form-item">
        <div class="title">确认密码</div>
        <div class="content">
          <input type="password" placeholder="请再次输入密码" v-model="re_password"  />
          <div class="tips"></div>
        </div>
      </div>



      <!--<div class="agree-xieyi">
        <div class="checkbox-wrapper">
          <label class="well-check">
            <input type="checkbox" v-model="xieyiOk" />
            <i class="icon"></i>
            已阅读并同意 <span class="xieyi">《用户协议》</span>
          </label>
        </div>
      </div>-->
    </div>
    <div class="register-action" :class="{'disabled':!canSubmit}" @click="registerAction">注册</div>
  </div>
</template>

<style lang="scss" scoped>
  .register-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #fff;
    padding: 0.26rem 0.34rem;
    position: relative;
    overflow-y: scroll;
    .close {
      position: absolute;
      width: 0.4rem;
      height: 0.4rem;
      color: #888;
      line-height: 0.4rem;
      text-align: center;
      font-size: 0.46rem;
    }
    .header-title {
      padding: 0.5rem 0 0;
      color: #333;
      font-size: 0.64rem;
      transition: 0.5s;
    }
    .form {
      .form-item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #f0f0f0;
        padding: 0.24rem 0;
        margin-top: 0.28rem;
        &:first-of-type{
          margin-top:0;
        }
        .title {
          width: 1.8rem;
          color: #333;
          font-size: 0.36rem;
          text-align: left;
        }
        .content {
          flex: 1;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          margin-left: 0.1rem;
          .tips {
            width: 3em;
            font-size: 0.32rem;
            margin-left: 0.2rem;
            text-align: right;
          }
          .get-code {
            flex: 1;
            color: #3d81ff;
            font-size: 0.24rem;
            text-align: right;
            min-width: 1.2rem;
          }
          input,select {
            flex: 1;
            font-size: 0.32rem;
          }
          input::-webkit-input-placeholder,select::-webkit-input-placeholder {
            color: #999;
          }
        }
      }
      .agree-xieyi {
        margin-top: 0.4rem;
        color: #999;
        font-size: 0.24rem;
        .checkbox-wrapper {
          padding-left: 0.32rem;
          .icon {
            width: 0.28rem;
            height: 0.28rem;
          }
          .xieyi {
            color: #fe5c48;
          }
        }
      }
    }
  }

  .register-action {
    font-size: 0.36rem;
    width: 7rem;
    height: 0.9rem;
    border-radius: 0.1rem;
    text-align: center;
    line-height: 0.9rem;
    color: #ffffff;
    margin-top: 2rem;
    background-color: #f44939;
  }
  .register-action.disabled{
    background-color: #ef9088;
  }

</style>
<script>
  import sendVerifyCode from "@mixins/SendVerifyCode";
  import { chs_phone, required } from "@utils/validate";
  import { validatorDefaultCatch } from "@utils/dialog";
  import {  userRegister } from "@api/user";
  import {getOtherAccountNew} from "../../api/user";



  export default {
    name: "UserRegister",
    data: function() {
      return {
        logoUrl: "",
        keyCode: "",
        phone: "",
        captcha: "",
        nickName:'',
        IDCard: "",
        other_nickname1:'',
        spread_phone: this.$route.params.network_phone,
        area:this.$route.params.area!=undefined?this.$route.params.area:0,
        password:'',
        re_password:'',
        xieyiOk: 0,
        canSubmit:true,
        lock_account: this.$route.params.lock_account,
      };
    },
    mixins: [sendVerifyCode],
    mounted() {
      this.lock_account = this.$route.params.lock_account;
      this.spread_phone = this.$route.params.network_phone;
      this.area = this.$route.params.area!=undefined?this.$route.params.area:0;

      this.getOtherAccount1();
    },
    watch: {
      $route(n) {
        if (n.name === "UserRegister") {
          this.lock_account = this.$route.params.lock_account;
          this.spread_phone = this.$route.params.network_phone;
          this.area = this.$route.params.area!=undefined?this.$route.params.area:0;



        }
      }
    },
    methods: {
      getOtherAccount1: function() {
        let that = this,account = that.spread_phone;
        console.log(3333)
        if(account!='') {
          getOtherAccountNew(
              {
                'account': account
              }
          ).then(
              res => {
                that.other_nickname1 = res.data.other_nickname;
              },
              err => {
                that.other_nickname1 = err.msg;
                that.$dialog.message(err.msg);
              }
          );
        }
      },
      /**
       * 新注册操作
       */
      async registerAction() {
        if (!this.canSubmit) {
          this.$dialog.toast({mes:'数据查询中，请稍后'})
          return false
        }
        this.canSubmit = false;
        let that = this;
        // 正常注册流程
        const { phone, spread_phone, nickName,area,password,re_password } = this;
        try {
          await this.$validator({
            phone: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message("手机号码"))
            ],
            nickName: [required(required.message("姓名"))],
            spread_phone: [
              required(required.message("推荐人会员号"))
            ],
            password: [
              required(required.message("请填写密码"))
            ]
          }).validate({ phone, nickName, spread_phone,password });//
        } catch (e) {
          this.canSubmit = true;
          return validatorDefaultCatch(e);
        }

        if(password!=re_password){
          this.canSubmit = true;
          this.$dialog.toast({mes:'密码不一致'})
          return false
        }

        userRegister({
          phone: this.phone,
          //captcha: this.captcha,
          nick_name: this.nickName,
          //IDCard: this.IDCard,
          spread_phone: this.spread_phone,
          lock_account:this.lock_account,
          area:this.area,
          password:this.password,
          //ok: this.xieyiOk,
          //cacheKey: this.cacheKey
        })
                .then(res => {
                  let { data } = res;

                  that.$dialog.success("注册成功").then(() => {
                    location.href = "/user/register_list";
                  });
                })
                .catch(err => {
                  this.$dialog.error(err.msg);
                  that.canSubmit = true;
                });
      }
    }
  };
</script>
